/**
 * Available report types
 */
export type ReportType =
  | 'no-go'
  | 'leads-closed'
  | 'leads-received'
  | 'current-job-costs'
  | 'unsold-open-leads'
  | 'open-sold-jobs';

/**
 * Available output formats for reports
 */
export type ReportFormat = 'xlsx' | 'pdf';

/**
 * Definition for a report including metadata
 */
export interface ReportDefinition {
  id: ReportType;
  name: string;
  description: string;
  requiresDateRange: boolean;
}

/**
 * Filters for date-based reports
 */
export interface ReportFilters {
  startDate?: string;
  endDate?: string;
}

/**
 * All available reports with their metadata
 */
export const REPORTS: ReportDefinition[] = [
  {
    id: 'no-go',
    name: 'No Go Last Month',
    description: 'Leads marked as NoGo within date range',
    requiresDateRange: true,
  },
  {
    id: 'leads-closed',
    name: 'Leads Closed Last Month',
    description: 'Leads marked as Closed within date range',
    requiresDateRange: true,
  },
  {
    id: 'leads-received',
    name: 'Leads Received Last Month',
    description: 'All leads received within date range',
    requiresDateRange: true,
  },
  {
    id: 'current-job-costs',
    name: 'Current Job Costs',
    description: 'Open sold jobs with financial details',
    requiresDateRange: false,
  },
  {
    id: 'unsold-open-leads',
    name: 'Unsold Open Leads',
    description: 'Leads that are Unassigned or Assigned',
    requiresDateRange: false,
  },
  {
    id: 'open-sold-jobs',
    name: 'Open Sold Jobs',
    description: 'Sold jobs that are not yet Closed',
    requiresDateRange: false,
  },
];
